import type { ValueOf } from '#layers/base/public';

export const IndexKind = {
	Primary: 'primary',
	Unique: 'unique',
	Normal: 'normal',
} as const;

export const INDEX_KINDS = [
	IndexKind.Normal,
	IndexKind.Unique,
	IndexKind.Primary,
];

export type IndexKind = ValueOf<typeof IndexKind>;

/** Mirrors the engine's collection method vocabulary. Types `queryCapabilities`; no UI gates on it yet. */
export const CollectionMethod = {
	Read: 'read',
	ReadOne: 'readOne',
	Create: 'create',
	Update: 'update',
	Delete: 'delete',
} as const;

export type CollectionMethod = ValueOf<typeof CollectionMethod>;

/**
 * Mirrors the engine's filterable-operator vocabulary. Distinct from `FilterOperator` in
 * `types/filters.ts`, which is Studio's wire filter DSL (`_eq`, `_between`); these nine gate which of
 * those may be offered, and the two do not map one-to-one. Types `queryCapabilities`; nothing narrows
 * on it yet.
 */
export const QueryCapabilityOperator = {
	Equals: 'equals',
	Contains: 'contains',
	Icontains: 'icontains',
	StartsWith: 'startsWith',
	EndsWith: 'endsWith',
	LessThan: 'lessThan',
	LessThanOrEquals: 'lessThanOrEquals',
	GreaterThan: 'greaterThan',
	GreaterThanOrEquals: 'greaterThanOrEquals',
} as const;

export type QueryCapabilityOperator = ValueOf<typeof QueryCapabilityOperator>;

export const ReferentialAction = {
	Cascade: 'cascade',
	Restrict: 'restrict',
	NoAction: 'noAction',
	SetNull: 'setNull',
	SetDefault: 'setDefault',
} as const;

export const REFERENTIAL_ACTIONS = [
	ReferentialAction.NoAction,
	ReferentialAction.Cascade,
	ReferentialAction.Restrict,
	ReferentialAction.SetNull,
	ReferentialAction.SetDefault,
];

export type ReferentialAction = ValueOf<typeof ReferentialAction>;
